module.exports = "/images/dropdown-arrow.svg?92c35f7a2081e36aa7ebd8baa46e7044";